import { axiosClient } from '../../../../services/axiosInstance'
import { OrderForm } from '../../entity/orderForm'
import type { OrderItemOnAdd, OrderItemOnUpdate } from '../types'
import storeConfig from '../../../../../store.config'

export const addCartItems = async (
  orderFormId: string,
  orderItems: OrderItemOnAdd[]
) => {
  const { data } = await axiosClient.post(
    `/api/checkout/orderForm/${orderFormId}/items?sc=${storeConfig.sc}`,
    {
      orderItems,
    },
    {
      headers: { 'Content-Type': 'application/json' },
    }
  )

  return new OrderForm(data)
}

export const updateCartItems = async (
  orderFormId: string,
  orderItems: OrderItemOnUpdate[]
) => {
  const { data } = await axiosClient.post(
    `/api/checkout/orderForm/${orderFormId}/items/update?allowedOutdatedData=paymentData`,
    {
      orderItems,
    },
    {
      headers: { 'Content-Type': 'application/json' },
    }
  )

  return new OrderForm(data)
}
